import React from "react";
import "./cars.style.sass";
import { connect } from "react-redux";
import Axios from "axios";
import * as L from "leaflet";
import { Alert } from "rsuite";
import { createStructuredSelector } from "reselect";
import {
  selectCarsData,
  selectInterval,
  selectPlayPause,
  selectReports,
  selectSelectedCarInfo,
  selectSingleCarData,
} from "../../redux/cars/cars.selector";
import {
  selectMap,
  selectIsMain,
  selectIconsLayer,
  selectReportLayer,
  selectRefresher,
  selectRefresherTime,
} from "../../redux/map/map.selector";
import { selectToken, selectUserInfo } from "../../redux/user/user.selector";
import {
  GetCarsData,
  GetReports,
  RemoveCarsData,
  RemoveSelectedCar,
  SetIcons,
  SetInterval,
  SetReportIndex,
  SetSelectedSingleCar,
} from "../../redux/cars/cars.action";
import {
  RefreshRefresher,
  SetIconsLayer,
  SetMainRefresherTimer,
  SetRefresher,
} from "../../redux/map/map.actions";
//ICONS
import carg from "../../assets/icons/carg.png";
import carr from "../../assets/icons/carr.png";
import cargr from "../../assets/icons/cargr.png";
import cary from "../../assets/icons/car_y.png";
import vanr from "../../assets/icons/van_red.png";
import vangr from "../../assets/icons/van_gr.png";
import vany from "../../assets/icons/van_y.png";
import vang from "../../assets/icons/van_green.png";
import truckr from "../../assets/icons/truck_red.png";
import truckgr from "../../assets/icons/truck_gr.png";
import trucky from "../../assets/icons/truck_y.png";
import truckg from "../../assets/icons/truck_green.png";
import taxir from "../../assets/icons/taxi_red.png";
import taxigr from "../../assets/icons/taxi_gr.png";
import taxiy from "../../assets/icons/taxi_yl.png";
import taxig from "../../assets/icons/taxi_green.png";
import busr from "../../assets/icons/bus_red.png";
import busgr from "../../assets/icons/bus_gr.png";
import busy from "../../assets/icons/bus_Y.png";
import busg from "../../assets/icons/bus_green.png";
import motorr from "../../assets/icons/motor_red.png";
import motorgr from "../../assets/icons/motor_gr.png";
import motory from "../../assets/icons/motor_y.png";
import motorg from "../../assets/icons/motor_green.png";
import bicycler from "../../assets/icons/bicycle_red.png";
import bicyclegr from "../../assets/icons/bicycle_gr.png";
import bicycleg from "../../assets/icons/bicycle_green.png";
import shipr from "../../assets/icons/ship_red.png";
import shipgr from "../../assets/icons/ship_gr.png";
import shipy from "../../assets/icons/ship_y.png";
import shipg from "../../assets/icons/ship_green.png";
import metror from "../../assets/icons/metro_red.png";
import metrogr from "../../assets/icons/metro_gr.png";
import metroy from "../../assets/icons/metro_y.png";
import metrog from "../../assets/icons/metro_green.png";
import ambolancer from "../../assets/icons/ambolance_red.png";
import ambolancegr from "../../assets/icons/ambolance_gr.png";
import ambolancey from "../../assets/icons/ambolance_y.png";
import ambolanceg from "../../assets/icons/ambolance_green.png";
import dogr from "../../assets/icons/dog_red.png";
import doggr from "../../assets/icons/dog_gr.png";
import dogg from "../../assets/icons/dog_green.png";
import personr from "../../assets/icons/person_red.png";
import persongr from "../../assets/icons/person_gr.png";
import persong from "../../assets/icons/person_green.png";
import mapTypes from "../../redux/map/map.types";
import carsTypes from "../../redux/cars/cars.types";
import { BiggerTime, ToPersianDate } from "../../script";
import UserTypes from "../../redux/user/user.types";
import { SetToken } from "../../redux/user/user.actions";

class CarsLayer extends React.Component {
  componentDidMount() {
    const {
      getMap,
      selectUser,
      setCars,
      SetIcons,
      SetIconsLayer,
      RefreshCountDown,
      getSingleCarData,
      getCarInfo,
      SetRefresher,
      getMarkerLayers,
      getReportLayer,
      ClearIconsLayer,
      getToken,
      iconLayer,
      ClearReportLayer,
      getInterval,
      SetInterval,
      getReports,
      setReports,
      playPause,
      TogglePlayPause,
      UserRemove,
      RemoveSelectedCar,
      RemoveCarsData,
      RemoveSingleCarData,
      RemoveToken,
    } = this.props;

    const dayInMS = 1000 * 60 * 60 * 24;
    const Now = Math.floor(new Date().getTime());
    const day5 = new Date(Now - dayInMS * 5).getTime();
    const day3 = new Date(Now - dayInMS * 3).getTime();
    let map = getMap;

    /** CLEAR MAP */
    if (getMarkerLayers.length) {
      getMarkerLayers.map((item) => map.removeLayer(item));
      ClearIconsLayer();
    }
    if (getReportLayer.length) {
      getReportLayer.map((item) => map.removeLayer(item));
      ClearReportLayer();
      SetReportIndex(0);
    }
    if (getInterval) {
      clearInterval(getInterval);
      SetInterval(0);
    }
    if (playPause) {
      TogglePlayPause();
    }
    if (getReports.length) {
      setReports([]);
    }

    if (getCarInfo) {
      Axios.post(`${getToken}/lastCars`, JSON.stringify(selectUser)).then(
        (res) => {
          if (res.data.success === "true") {
            setCars(res);
            let car = res.data.data.find(
              (item) => item.DeviceID == getCarInfo.ID
            );
            let markersLayer;
            let iconUrl = carg;
            //SWITCH
            switch (car.Application) {
              case 0:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = carr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = cargr;
                } else if (car.Switch) {
                  iconUrl = cary;
                } else {
                  iconUrl = carg;
                }
                break;
              case 1:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = vanr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = vangr;
                } else if (car.Switch) {
                  iconUrl = vany;
                } else {
                  iconUrl = vang;
                }
                break;
              case 2:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = truckr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = truckgr;
                } else if (car.Switch) {
                  iconUrl = trucky;
                } else {
                  iconUrl = truckg;
                }
                break;
              case 3:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = taxir;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = taxigr;
                } else if (car.Switch) {
                  iconUrl = taxiy;
                } else {
                  iconUrl = taxig;
                }
                break;
              case 4:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = busr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = busgr;
                } else if (car.Switch) {
                  iconUrl = busy;
                } else {
                  iconUrl = busg;
                }
                break;
              case 5:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = motorr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = motorgr;
                } else if (car.Switch) {
                  iconUrl = motory;
                } else {
                  iconUrl = motorg;
                }
                break;
              case 6:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = bicycler;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = bicyclegr;
                } else {
                  iconUrl = bicycleg;
                }
                break;
              case 7:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = shipr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = shipgr;
                } else if (car.Switch) {
                  iconUrl = shipy;
                } else {
                  iconUrl = shipg;
                }
                break;
              case 8:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = metror;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = metrogr;
                } else if (car.Switch) {
                  iconUrl = metroy;
                } else {
                  iconUrl = metrog;
                }
                break;
              case 9:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = ambolancer;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = ambolancegr;
                } else if (car.Switch) {
                  iconUrl = ambolancey;
                } else {
                  iconUrl = ambolanceg;
                }
                break;
              case 10:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = dogr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = doggr;
                } else {
                  iconUrl = dogg;
                }
                break;
              case 11:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = personr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = persongr;
                } else {
                  iconUrl = persong;
                }
                break;
              default:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = carr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = cargr;
                } else if (car.Switch) {
                  iconUrl = cary;
                } else {
                  iconUrl = carg;
                }
                break;
            }
            let icon = L.icon({
              iconUrl: iconUrl,
              iconAnchor: [15, 22],
              popupAnchor: [0, -20],
              iconSize: new L.Point(30, 45),
            });

            SetIcons(icon);

            markersLayer = new L.marker([car.Latitude, car.Longitude], {
              icon: icon,
              rotationAngle: car.COG * 30,
            });

            let myPopup = `
                                     <b>${car.Name}</b><br>
                                     <span>${ToPersianDate(
                                       car.Date
                                     )}</span><br/>
                                     <span>وضعیت سویچ : ${
                                       car.Switch ? "باز" : "بسته"
                                     }</span><br/>
                                     <span>وضعیت درب ها : ${
                                       car.Door ? "باز" : "بسته"
                                     }</span><br/>
                                     <span>سرعت : ${
                                       car.Speed
                                         ? `${car.Speed} کیلومتر`
                                         : "ساکن"
                                     }</span><br/>
                                     <span>دما : ${car.Temperature}</span><br />
                                     <span>وضعیت رله : ${
                                       car.Relay ? "قطع" : "وصل"
                                     }</span><br />
                            `;

            markersLayer.bindPopup(myPopup);
            let layerOfMarks = L.layerGroup([markersLayer]);
            map.addLayer(layerOfMarks);
            SetIconsLayer(markersLayer);

            /** SET TIMER */
            let timer = setInterval(() => RefreshCountDown(), 1000);
            SetRefresher(timer);
          } else {
            iconLayer.map((x) => map.removeLayer(x));
            UserRemove();
            RemoveCarsData();
            RemoveSelectedCar();
            RemoveToken();
            RemoveSingleCarData();
            Alert.error("برای شما خودرو ای ثبت نشده است.", 4000);
          }
        }
      );
    } else {
      let CarsWithOutPoint = [];
      Axios.post(`${getToken}/lastCars`, JSON.stringify(selectUser)).then(
        (res) => {
          if (res.data.success === "true") {
            res.data.data.map((item) => {
              if (!item.Latitude && !item.Longitude) {
                CarsWithOutPoint.push(item);
              }
            });
            setCars(res);
            res.data.data.map((car) => {
              let markersLayer;
              let iconUrl = carg;
              //SWITCH
              switch (car.Application) {
                case 0:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = carr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = cargr;
                  } else if (car.Switch) {
                    iconUrl = cary;
                  } else {
                    iconUrl = carg;
                  }
                  break;
                case 1:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = vanr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = vangr;
                  } else if (car.Switch) {
                    iconUrl = vany;
                  } else {
                    iconUrl = vang;
                  }
                  break;
                case 2:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = truckr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = truckgr;
                  } else if (car.Switch) {
                    iconUrl = trucky;
                  } else {
                    iconUrl = truckg;
                  }
                  break;
                case 3:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = taxir;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = taxigr;
                  } else if (car.Switch) {
                    iconUrl = taxiy;
                  } else {
                    iconUrl = taxig;
                  }
                  break;
                case 4:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = busr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = busgr;
                  } else if (car.Switch) {
                    iconUrl = busy;
                  } else {
                    iconUrl = busg;
                  }
                  break;
                case 5:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = motorr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = motorgr;
                  } else if (car.Switch) {
                    iconUrl = motory;
                  } else {
                    iconUrl = motorg;
                  }
                  break;
                case 6:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = bicycler;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = bicyclegr;
                  } else {
                    iconUrl = bicycleg;
                  }
                  break;
                case 7:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = shipr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = shipgr;
                  } else if (car.Switch) {
                    iconUrl = shipy;
                  } else {
                    iconUrl = shipg;
                  }
                  break;
                case 8:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = metror;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = metrogr;
                  } else if (car.Switch) {
                    iconUrl = metroy;
                  } else {
                    iconUrl = metrog;
                  }
                  break;
                case 9:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = ambolancer;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = ambolancegr;
                  } else if (car.Switch) {
                    iconUrl = ambolancey;
                  } else {
                    iconUrl = ambolanceg;
                  }
                  break;
                case 10:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = dogr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = doggr;
                  } else {
                    iconUrl = dogg;
                  }
                  break;
                case 11:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = personr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = persongr;
                  } else {
                    iconUrl = persong;
                  }
                  break;
                default:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = carr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = cargr;
                  } else if (car.Switch) {
                    iconUrl = cary;
                  } else {
                    iconUrl = carg;
                  }
                  break;
              }

              let icon = L.icon({
                iconUrl: iconUrl,
                iconAnchor: [15, 22],
                popupAnchor: [0, -20],
                iconSize: new L.Point(30, 45),
              });

              SetIcons(icon);

              markersLayer = new L.marker([car.Latitude, car.Longitude], {
                icon: icon,
                rotationAngle: car.COG * 30,
              });

              let myPopup = `
                                 <b>${car.Name}</b><br>
                                 <span>${ToPersianDate(car.Date)}</span><br/>
                                 <span>وضعیت سویچ : ${
                                   car.Switch ? "باز" : "بسته"
                                 }</span><br/>
                                 <span>وضعیت درب ها : ${
                                   car.Door ? "باز" : "بسته"
                                 }</span><br/>
                                 <span>سرعت : ${
                                   car.Speed ? `${car.Speed} کیلومتر` : "ساکن"
                                 }</span><br/>
                                 <span>دما : ${car.Temperature}</span><br />
                                 <span>وضعیت رله : ${
                                   car.Relay ? "قطع" : "وصل"
                                 }</span><br />
                        `;

              markersLayer.bindPopup(myPopup);
              let layerOfMarks = L.layerGroup([markersLayer]);
              map.addLayer(layerOfMarks);
              SetIconsLayer(markersLayer);
            });

            /** SET TIMER */
            let timer = setInterval(() => RefreshCountDown(), 1000);
            SetRefresher(timer);
          } else {
            iconLayer.map((x) => map.removeLayer(x));
            UserRemove();
            RemoveCarsData();
            RemoveSelectedCar();
            RemoveToken();
            RemoveSingleCarData();
            Alert.error("برای شما خودرو ای ثبت نشده است.", 4000);
          }
        }
      );
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      RemoveSingleCarData,
      getMap,
      selectUser,
      setCars,
      SetIcons,
      SetIconsLayer,
      RemoveToken,
      UserRemove,
      iconLayer,
      getCarInfo,
      RefreshRefresher,
      getMarkerLayers,
      getReportLayer,
      ClearIconsLayer,
      getToken,
      ClearReportLayer,
      getInterval,
      getRefreshTime,
      getReports,
      setReports,
      playPause,
      TogglePlayPause,
    } = this.props;

    const dayInMS = 1000 * 60 * 60 * 24;
    const Now = Math.floor(new Date().getTime());
    const day5 = new Date(Now - dayInMS * 5).getTime();
    const day3 = new Date(Now - dayInMS * 3).getTime();

    let map = getMap;
    if (!getCarInfo && prevProps.getRefreshTime === 1 && getRefreshTime === 0) {
      /** CLEAR MAP */
      if (getMarkerLayers.length) {
        getMarkerLayers.map((item) => map.removeLayer(item));
        ClearIconsLayer();
      }
      if (getReportLayer.length) {
        getReportLayer.map((item) => map.removeLayer(item));
        ClearReportLayer();
        SetReportIndex(0);
      }
      if (getInterval) {
        clearInterval(getInterval);
        SetInterval(0);
      }
      if (playPause) {
        TogglePlayPause();
      }
      if (getReports.length) {
        setReports([]);
      }
      Axios.post(`${getToken}/lastCars`, JSON.stringify(selectUser)).then(
        (res) => {
          if (res.data.success === "true") {
            setCars(res);
            res.data.data.map((car) => {
              let markersLayer;
              let iconUrl = carg;
              // 1626086623
              // 1626086071
              //SWITCH
              switch (car.Application) {
                case 0:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = carr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = cargr;
                  } else if (!!car.Switch) {
                    iconUrl = cary;
                  } else {
                    iconUrl = carg;
                  }
                  break;
                case 1:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = vanr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = vangr;
                  } else if (!!car.Switch) {
                    iconUrl = vany;
                  } else {
                    iconUrl = vang;
                  }
                  break;
                case 2:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = truckr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = truckgr;
                  } else if (car.Switch) {
                    iconUrl = trucky;
                  } else {
                    iconUrl = truckg;
                  }
                  break;
                case 3:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = taxir;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = taxigr;
                  } else if (car.Switch) {
                    iconUrl = taxiy;
                  } else {
                    iconUrl = taxig;
                  }
                  break;
                case 4:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = busr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = busgr;
                  } else if (car.Switch) {
                    iconUrl = busy;
                  } else {
                    iconUrl = busg;
                  }
                  break;
                case 5:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = motorr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = motorgr;
                  } else if (car.Switch) {
                    iconUrl = motory;
                  } else {
                    iconUrl = motorg;
                  }
                  break;
                case 6:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = bicycler;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = bicyclegr;
                  } else {
                    iconUrl = bicycleg;
                  }
                  break;
                case 7:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = shipr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = shipgr;
                  } else if (car.Switch) {
                    iconUrl = shipy;
                  } else {
                    iconUrl = shipg;
                  }
                  break;
                case 8:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = metror;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = metrogr;
                  } else if (car.Switch) {
                    iconUrl = metroy;
                  } else {
                    iconUrl = metrog;
                  }
                  break;
                case 9:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = ambolancer;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = ambolancegr;
                  } else if (car.Switch) {
                    iconUrl = ambolancey;
                  } else {
                    iconUrl = ambolanceg;
                  }
                  break;
                case 10:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = dogr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = doggr;
                  } else {
                    iconUrl = dogg;
                  }
                  break;
                case 11:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = personr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = persongr;
                  } else {
                    iconUrl = persong;
                  }
                  break;
                default:
                  if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day5 / 1000
                  ) {
                    iconUrl = carr;
                  } else if (
                    BiggerTime(car.SimDebitLastUpdate, car.Time) <
                    day3 / 1000
                  ) {
                    iconUrl = cargr;
                  } else if (car.Switch) {
                    iconUrl = cary;
                  } else {
                    iconUrl = carg;
                  }
                  break;
              }

              let icon = L.icon({
                iconUrl: iconUrl,
                iconAnchor: [15, 22],
                popupAnchor: [0, -20],
                iconSize: new L.Point(30, 45),
              });

              SetIcons(icon);

              markersLayer = new L.marker([car.Latitude, car.Longitude], {
                icon: icon,
                rotationAngle: car.COG * 30,
              });

              let myPopup = `
                                 <b>${car.Name}</b><br>
                                 <span>${ToPersianDate(car.Date)}</span><br/>
                                 <span>وضعیت سویچ : ${
                                   car.Switch ? "باز" : "بسته"
                                 }</span><br/>
                                 <span>وضعیت درب ها : ${
                                   car.Door ? "باز" : "بسته"
                                 }</span><br/>
                                 <span>سرعت : ${
                                   car.Speed ? `${car.Speed} کیلومتر` : "ساکن"
                                 }</span><br/>
                                 <span>دما : ${car.Temperature}</span><br />
                                 <span>وضعیت رله : ${
                                   car.Relay ? "قطع" : "وصل"
                                 }</span><br />
                        `;

              markersLayer.bindPopup(myPopup);
              let layerOfMarks = L.layerGroup([markersLayer]);
              map.addLayer(layerOfMarks);
              SetIconsLayer(markersLayer);
            });
          } else {
            iconLayer.map((x) => map.removeLayer(x));
            UserRemove();
            RemoveCarsData();
            RemoveSelectedCar();
            RemoveToken();
            RemoveSingleCarData();
            Alert.error("برای شما خودرو ای ثبت نشده.");
          }
        }
      );
    } else if (
      getCarInfo &&
      prevProps.getRefreshTime === 1 &&
      getRefreshTime === 0
    ) {
      /** CLEAR MAP */
      if (getMarkerLayers.length) {
        getMarkerLayers.map((item) => map.removeLayer(item));
        ClearIconsLayer();
      }
      if (getReportLayer.length) {
        getReportLayer.map((item) => map.removeLayer(item));
        ClearReportLayer();
        SetReportIndex(0);
      }
      if (getInterval) {
        clearInterval(getInterval);
        SetInterval(0);
      }
      if (playPause) {
        TogglePlayPause();
      }
      if (getReports.length) {
        setReports([]);
      }

      Axios.post(`${getToken}/lastCars`, JSON.stringify(selectUser)).then(
        (res) => {
          if (res.data.success === "true") {
            setCars(res);
            let car = res.data.data.find(
              (item) => item.DeviceID == getCarInfo.ID
            );
            let markersLayer;
            let iconUrl = carg;

            //SWITCH
            switch (car.Application) {
              case 0:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = carr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = cargr;
                } else if (car.Switch) {
                  iconUrl = cary;
                } else {
                  iconUrl = carg;
                }
                break;
              case 1:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = vanr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = vangr;
                } else if (car.Switch) {
                  iconUrl = vany;
                } else {
                  iconUrl = vang;
                }
                break;
              case 2:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = truckr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = truckgr;
                } else if (car.Switch) {
                  iconUrl = trucky;
                } else {
                  iconUrl = truckg;
                }
                break;
              case 3:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = taxir;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = taxigr;
                } else if (car.Switch) {
                  iconUrl = taxiy;
                } else {
                  iconUrl = taxig;
                }
                break;
              case 4:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = busr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = busgr;
                } else if (car.Switch) {
                  iconUrl = busy;
                } else {
                  iconUrl = busg;
                }
                break;
              case 5:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = motorr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = motorgr;
                } else if (car.Switch) {
                  iconUrl = motory;
                } else {
                  iconUrl = motorg;
                }
                break;
              case 6:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = bicycler;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = bicyclegr;
                } else {
                  iconUrl = bicycleg;
                }
                break;
              case 7:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = shipr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = shipgr;
                } else if (car.Switch) {
                  iconUrl = shipy;
                } else {
                  iconUrl = shipg;
                }
                break;
              case 8:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = metror;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = metrogr;
                } else if (car.Switch) {
                  iconUrl = metroy;
                } else {
                  iconUrl = metrog;
                }
                break;
              case 9:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = ambolancer;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = ambolancegr;
                } else if (car.Switch) {
                  iconUrl = ambolancey;
                } else {
                  iconUrl = ambolanceg;
                }
                break;
              case 10:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = dogr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = doggr;
                } else {
                  iconUrl = dogg;
                }
                break;
              case 11:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = personr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = persongr;
                } else {
                  iconUrl = persong;
                }
                break;
              default:
                if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day5 / 1000
                ) {
                  iconUrl = carr;
                } else if (
                  BiggerTime(car.SimDebitLastUpdate, car.Time) <
                  day3 / 1000
                ) {
                  iconUrl = cargr;
                } else if (car.Switch) {
                  iconUrl = cary;
                } else {
                  iconUrl = carg;
                }
                break;
            }

            let icon = L.icon({
              iconUrl: iconUrl,
              iconAnchor: [15, 22],
              popupAnchor: [0, -20],
              iconSize: new L.Point(30, 45),
            });

            SetIcons(icon);

            markersLayer = new L.marker([car.Latitude, car.Longitude], {
              icon: icon,
              rotationAngle: car.COG * 30,
            });

            let myPopup = `
                                 <b>${car.Name}</b><br>
                                 <span>${ToPersianDate(car.Date)}</span><br/>
                                 <span>وضعیت سویچ : ${
                                   car.Switch ? "باز" : "بسته"
                                 }</span><br/>
                                 <span>وضعیت درب ها : ${
                                   car.Door ? "باز" : "بسته"
                                 }</span><br/>
                                 <span>سرعت : ${
                                   car.Speed ? `${car.Speed} کیلومتر` : "ساکن"
                                 }</span><br/>
                                 <span>دما : ${car.Temperature}</span><br />
                                 <span>وضعیت رله : ${
                                   car.Relay ? "قطع" : "وصل"
                                 }</span><br />
                        `;

            markersLayer.bindPopup(myPopup);
            let layerOfMarks = L.layerGroup([markersLayer]);
            map.addLayer(layerOfMarks);
            SetIconsLayer(markersLayer);
          } else {
            iconLayer.map((x) => map.removeLayer(x));
            UserRemove();
            RemoveCarsData();
            RemoveSelectedCar();
            RemoveToken();
            RemoveSingleCarData();
            Alert.error("برای شما خودرو ای ثبت نشده.");
          }
        }
      );
    }

    if (
      (prevProps.getRefreshTime === 1 && getRefreshTime === 0) ||
      getRefreshTime < -3
    ) {
      RefreshRefresher(document.getElementById("chouseMainRefresher").value);
    }
  }

  componentWillUnmount() {
    const {
      getRefresher,
      RefreshRefresher,
      getMarkerLayers,
      getReportLayer,
      ClearIconsLayer,
      getMap,
      ClearReportLayer,
      getInterval,
      SetInterval,
      getReports,
      setReports,
      playPause,
      TogglePlayPause,
    } = this.props;
    clearInterval(getRefresher);
    RefreshRefresher(20);
    let map = getMap;
    /** CLEAR MAP */
    if (getMarkerLayers.length) {
      getMarkerLayers.map((item) => map.removeLayer(item));
      ClearIconsLayer();
    }
    if (getReportLayer.length) {
      getReportLayer.map((item) => map.removeLayer(item));
      ClearReportLayer();
      SetReportIndex(0);
    }
    if (getInterval) {
      clearInterval(getInterval);
      SetInterval(0);
    }
    if (playPause) {
      TogglePlayPause();
    }
    if (getReports.length) {
      setReports([]);
    }
  }

  render() {
    const { getRefreshTime, ChoseRefresherTime } = this.props;

    const ChooseMainRefresher = () => {
      let Value = document.getElementById("chouseMainRefresher").value;
      ChoseRefresherTime(Value);
    };

    return (
      <div className="cars-layer">
        <div className="cars-layer-timer-div">
          <span>بروز رسانی در :</span>
          <span style={{ margin: "0 5px" }}>
            <strong style={{ color: "orange" }}>{getRefreshTime}</strong>
          </span>
          <span>ثانیه دیگر</span>
          <select
            className="cars-selectPicker"
            onChange={() => ChooseMainRefresher()}
            id="chouseMainRefresher"
          >
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
          </select>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  CarsData: selectCarsData,
  getMap: selectMap,
  selectUser: selectUserInfo,
  getUser: selectUserInfo,
  IsMain: selectIsMain,
  iconLayer: selectIconsLayer,
  reportLayer: selectReportLayer,
  getCarInfo: selectSelectedCarInfo,
  getRefresher: selectRefresher,
  getMarkerLayers: selectIconsLayer,
  getReportLayer: selectReportLayer,
  getInterval: selectInterval,
  playPause: selectPlayPause,
  getReports: selectReports,
  getRefreshTime: selectRefresherTime,
  getToken: selectToken,
  getSingleCarData: selectSingleCarData,
});
const mapDispatchToProps = (dispatch) => ({
  setCars: (res) => dispatch(GetCarsData(res)),
  SetIcons: (icon) => dispatch(SetIcons(icon)),
  SetIconsLayer: (layer) => dispatch(SetIconsLayer(layer)),
  SetRefresher: (refresher) => dispatch(SetRefresher(refresher)),
  RefreshRefresher: (time) => dispatch(RefreshRefresher(time)),
  ClearIconsLayer: () => dispatch({ type: mapTypes.CLEAR_ICONS_LAYER }),
  ClearReportLayer: () => dispatch({ type: mapTypes.CLEAR_REPORT_LAYER }),
  SetReportIndex: (index) => dispatch(SetReportIndex(index)),
  SetInterval: (interval) => dispatch(SetInterval(interval)),
  setReports: (report) => dispatch(GetReports(report)),
  TogglePlayPause: () => dispatch({ type: carsTypes.PLAY_PAUSE }),
  RefreshCountDown: () => dispatch({ type: mapTypes.REFRESHER_COUNT_DOWN }),
  ChoseRefresherTime: (sec) => dispatch(SetMainRefresherTimer(sec)),
  UserRemove: () => dispatch({ type: UserTypes.REMOVE_USER }),
  RemoveCarsData: () => dispatch(RemoveCarsData()),
  RemoveSelectedCar: () => dispatch(RemoveSelectedCar()),
  RemoveToken: () => dispatch(SetToken("")),
  RemoveSingleCarData: () => dispatch(SetSelectedSingleCar("")),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarsLayer);
